export type SetServerTimeAction = {
  type: 'SET_SERVER_TIME_OFFSET';
  payload?: number;
};

export const setServerTimeOffset = (payload?: number): SetServerTimeAction => ({
  type: 'SET_SERVER_TIME_OFFSET',
  payload
});
